import { EdgeRevokeImpersonationRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { RevokeImpersonation } from '@/modules/auth/use-cases'

export function makeRevokeImpersonation(): RevokeImpersonation {
  return new EdgeRevokeImpersonationRepository(makeSupabaseEdgeHttpClient()).execute
}
